<template>
      <div style="width:1300px;margin:0 auto;">
            <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:100px;">
               <P>
                   <button class="btn btn-primary ml-2 mt-2" @click="latestSale()">统计最近日销售</button>
               </P>
                  <h5 class="text-center">
                      <span>
                        总销售
                      </span>
                       <span class="span_font_big">
                           {{totalAmount | sp}}
                       </span>
                      <span class="span_font_small">
                          {{totalAmount | subs}}
                      </span>
                      <span class="span_wan">
                          万
                      </span>
                      <span class="ml-2">
                        线上总销售
                      </span>
                      <span class="span_font_big">
                          {{retailAmount | sp}}
                      </span>
                      <span class="span_font_small">
                          {{retailAmount | subs}}
                      </span>
                      <span class="span_wan">
                          万
                      </span>
                      <span class="ml-2">
                       零库销售
                      </span>
                      <span class="span_font_big">
                          {{netAmount | sp}}
                      </span>
                      <span class="span_font_small">
                          {{netAmount | subs}}
                      </span>
                      <span class="span_wan">
                          万
                      </span>
                  </h5>
                   <!-- <h5 class="text-center">
                            <span>
                                  库存汇总
                            </span>
                            <span class="ml-2">
                              成本
                            </span>
                            <span class="span_font_big">
                                {{cost| sp}}
                            </span>
                            <span class="span_font_small">
                                {{cost | subs}}
                            </span>
                            <span class="span_wan">
                               万
                            </span>
                            <!-- <span class="ml-2">
                             毛利
                            </span>
                            <span class="span_font_big">
                                  {{profit | sp}}
                            </span>
                            <span class="span_font_small">
                                {{profit | subs}}
                            </span>
                            <span class="span_wan">
                                万
                            </span> -->
                           <!--   <span class="ml-2">
                             整库记录数
                            </span>
                            <span class="span_counts">
                                  {{counts}}
                            </span>

                             <span class="ml-2">
                             零库记录数
                            </span>
                            <span class="span_counts">
                                  {{retailCounts}}
                            </span>

                    </h5> -->
                  <div class="box">
                     <div id="myChart" :style="{width:'1000px',height:'400px'}">
                    </div>
                  </div>
            </div>
      </div>
</template>
<script>
export default {
    data(){
        return{
            netAmount:"",
            retailAmount:"",
            totalAmount:"",
            list:[],
            data1:[],
            data2:[],
            data3:[],
            data4:[],
            cost:'',
            profit:'',
            counts:'',
            retailCounts:"",
        }
    },
    filters:{
        subs(su){
           return  su.substring(su.length-5);
        },
        sp(sp){
            return sp.slice(0,sp.length-5);
        }
    },
    methods:{
         //跳转最近日销售
         latestSale(){
              this.$router.push({path: '/latestSale'})
         },
        //库存汇总
        StoreGoodsInfo: async function (PageIndex) {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'StoreGoodsInfo',
          obj: JSON.stringify({

          })
        })
        // console.log(res)
        if (res.isok) {
              const obj = res.data;
              this.profit =this.getFloat(res.data.all.profit/10000,4);
              this.cost =this.getFloat(res.data.all.cost/10000,4);
              this.counts = res.data.all.counts-res.data.retail.counts;
              this.retailCounts = res.data.retail.counts;
        }
        else{

        }
      },
        //保留小数
            getFloat (number, n) {
                n = n ? parseInt(n) : 0;
                if(n <= 0) {
                    return Math.round(number);
                }
                number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
                number = Number(number).toFixed(n); //补足位数
                return number;
            },
      //处理数据
         dispose(){
             const that=this;
            that.list.forEach(function(item){
                  that.data1.push(item.retailAmount)
                  that.data2.push(item.netAmount)
                  that.data3.push(item.totalAmount)
                  that.data4.push(that.getFloat(item.totalAmount-item.retailAmount-item.netAmount,2))
            });
            //    console.log(this.data1)
            //    console.log(this.data2)
            //    console.log(this.data3)
            //    console.log(this.data4)
               this.drawLine();
         },
        //当天销售情况-
        getSalesDataQuery: async function () {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'SaleTodayDataQuery',
          obj: JSON.stringify({

          })
        })
        // console.log(res)
        if (res.isok) {
             const obj = res.data;
             this.netAmount = this.getFloat(obj.netAmount/10000,4);
             this.retailAmount = this.getFloat(obj.retailAmount/10000,4);
             this.totalAmount =this.getFloat(obj.totalAmount/10000,4);
             this.list = obj.rows;
             this.dispose();

        }
      },
       //统计图
        drawLine(){
            // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'));
            // 绘制图表
        myChart.setOption({
    //     tooltip: {
    //     trigger: 'axis',
    //     axisPointer: {            // 坐标轴指示器，坐标轴触发有效
    //         type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
    //     }
    // },
    // legend: {
    //     data: ['线上销售', '零库销售', '其他', '总销售']
    // },
    // grid: {
    //     left: '3%',
    //     right: '4%',
    //     bottom: '3%',
    //     containLabel: true
    // },
    // xAxis: [
    //     {
    //         type: 'category',
    //         data: ['医药商城', '汉宁', '工业', '西药', '新特药', '药品', '药材']
    //     }
    // ],
    // yAxis: [
    //     {
    //                     type: 'value', //坐标轴类型
    //                     name: '金额', //名称
    //                     min: -20000, //最小值
    //                     max: 5000000, //最大值
    //                     interval: 500000, //列数
    //                     axisLabel: {  //坐标轴刻度标签的相关设置。
    //                         formatter: '{value}'  //字符串模板
    //                     }
    //     }
    // ],
    // series: [
    //     {
    //         name: '线上销售',
    //         type: 'bar',
    //         stack: '广告',
    //         data: this.data1,
    //     },
    //     {
    //         name: '零库销售',
    //         type: 'bar',
    //         stack: '广告',
    //         data: this.data2,
    //     },
    //     {
    //         name: '其他',
    //         type: 'bar',
    //         // stack: '广告',
    //         data: this.data4,
    //     },
    //     {
    //         name: '总销售',
    //         type: 'bar',
    //         data: this.data3,
    //         markLine: {
    //             lineStyle: {
    //                 type: 'dashed'
    //             },
    //             data: [
    //                 [{type: 'min'}, {type: 'max'}]
    //             ]
    //         }
    //     },
    // ]

                    title: [
						{
							text: '销售日报',
							left: 'center',
							top: 20,
							textStyle: {
								// color: 'blue',
								//fontSize: '14',
							},
						},
						{
							// text: '总销售',
							//borderColor: '#999',
							//borderWidth: 1,
							textStyle: {
								fontSize: 14
							},
							left: 'center',
							top: '88%'
						},
					],
					tooltip: {
						trigger: 'axis',//坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow' |'cross'
						}
					},
					legend: {
						data: ['总销售'],
						//bottom: '0',
					},
					grid: {
						left: '10%',
						right: '10%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisTick: { //坐标轴刻度相关设置。
							show: true,
						},
						data: ['医药商城', '汉宁', '工业', '西药', '新特药', '药品', '药材'],
						axisLine: {
							show: true, //是否显示坐标轴轴线。
//							//onZero:false,//X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
//							//symbol:'arrow', //轴线两边的箭头
							lineStyle: {
								width: 1,
								// color: '#36d',
							},
						},

					}],
					yAxis: [{
						type: 'value',
						// name: '金额',
						nameLocation: 'center',
                        nameGap: 40,
                        name:'金额',//坐标轴名称。
                        nameLocation:'end',//坐标轴名称显示位置。

					}],
					series: [
						// {
						// 	name: '线上销售',
						// 	type: 'bar',
						// 	label: { //图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
						// 		normal: { //正常情况
						// 			// show: true, //是否显示标签
						// 			position: 'inside', //标签的位置。
						// 			distance: 5, //距离图形元素的距离。当 position 为字符描述值（如 'top'、'insideRight'）时候有效。default: 5
						// 			rotate: 0, //标签旋转。从 -90 度到 90 度。正值是逆时针。

						// 		}
						// 	},
						// 	data: this.data1,
						// },
						// {
						// 	name: '零库销售',
						// 	type: 'bar',
						// 	stack: '零库', //数据堆叠，同个类目轴上系列配置相同的stack值可以堆叠放置。
						// 	label: {
						// 		normal: {
						// 			// show: true, //是否显示标签
						// 			position: 'inside', //标签的位置。
						// 		}
						// 	},
						// 	data:this.data2,
						// },
						// {
						// 	name: '其他',
						// 	type: 'bar',
						// 	stack: '总量',
						// 	label: {
						// 		normal: {//正常情况
						// 			// show: true, //是否显示标签
						// 			position: 'inside'
						// 		}
						// 	},
						// 	data: this.data4,
                        // },
                        {
							name: '总销售',
							type: 'bar',
							stack: '总销售',
							// label: {
							// 	normal: {//正常情况
							// 		// show: true, //是否显示标签
							// 		// position: 'inside'
							// 	}
							// },
                            data: this.data3,
                            itemStyle:{
                               normal:{
                                   color:"#29AAE3",
                                label:{
                                    show:true,
                                    position:'top',
                                    textStyle:{
                                         color: '#61a0a8'
                                    }
                                }
                               },
                            },
                            //  markLine: {
                            //         lineStyle: {
                            //             type: 'dashed'
                            //         },
                            //         data: [
                            //             [{type: 'min'}, {type: 'max'}]
                            //         ]
                            //     },
						}
					]

            });

        },
    },
    mounted(){
          this.drawLine();
    },
    created(){
        this.getSalesDataQuery();
        this.StoreGoodsInfo();
    }
}
</script>

<style scoped>
    .box{
        margin:0 auto;
    }
    .span_wan{
        color:red;
    }
    .span_font_big{
        font-size:30px;
        color:#f90;
    }
    .span_font_small{
        font-size:15px;
        color:#fe6d47;
    }
    .span_counts{
        color:#61a0a8;
    }
</style>



// WEBPACK FOOTER //
// src/pages/manager/SalesGournal.vue